import { render, staticRenderFns } from "./TkEdit.vue?vue&type=template&id=44acf986&scoped=true&"
import script from "./TkEdit.vue?vue&type=script&lang=js&"
export * from "./TkEdit.vue?vue&type=script&lang=js&"
import style0 from "./TkEdit.vue?vue&type=style&index=0&id=44acf986&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44acf986",
  null
  
)

export default component.exports